import React, { useRef, useState } from 'react';
import CollapsableCard from 'commons/card/CollapsableCard';
import Body from 'commons/card/Body';
import { Button } from '@progress/kendo-react-buttons';
import { Loader } from '@progress/kendo-react-indicators';
import { ListView } from '@progress/kendo-react-listview';
import { Label } from '@progress/kendo-react-labels';
import { NumericTextBox } from '@progress/kendo-react-inputs';
import { useLazyGetProjectQuery, useLazyGetTreqQuery } from '../../../redux/api/cache';

export default function TreqReport() {

  const [base64Xlsx, setBase64Xlsx] = useState(undefined);
  const [loadingXlsx, setLoadingXlsx] = useState(false);
  const [value, setValue] = useState(0);
  const [dataList, setDataList] = useState([]);
  const [getTreq] = useLazyGetTreqQuery();
  const [getProject] = useLazyGetProjectQuery();

  const linkRef = useRef(null);

  const handleSubmit = async () => {
    let temp = '';
    dataList.forEach((elem) => (temp += elem[0].camp_seq + ','));

    setLoadingXlsx(true);
    setBase64Xlsx(undefined);
    let result = await getTreq(temp).unwrap();
    if (result) {
      setBase64Xlsx(
        `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${result}`
      );
      linkRef.current.click();
    }
    setLoadingXlsx(false);
  };

  const remove = (item) => {
    let temp = dataList;

    temp.splice(
      temp.findIndex((elem) => elem[0].camp_seq === item.camp_seq),
      1
    );

    setDataList(temp);
    addList();
  };

  const MyItemRender = (props) => {
    if (props.dataItem === undefined) {
      return <div></div>;
    }

    let item = props.dataItem[0];

    if (item === undefined) {
      return <div></div>;
    }

    return (
      <div
        className='k-listview-item'
        style={{
          padding: 10,
          borderBottom: '1px solid lightgrey',
        }}
      >
        <Button
          icon={'close'}
          className='blueButton'
          style={{
            margin: '2px',
            borderRadius: '50%',
            marginRight: '15px',
            width: '20px',
            height: '20px',
          }}
          onClick={() => remove(item)}
        ></Button>
        <span>{item.camp_num + ' - ' + item.camp_descr}</span>
      </div>
    );
  };

  const ChangeValue = (e) => {
    setValue(e.value !== null ? e.value : null);
  };

  const addList = async() => {
    if (value !== undefined) {
      let result = await getProject({ camp_num: value }).unwrap();
      if (result.success) {
        dataList.push(result.data);
        setValue(0);
      }
    }
  };

  return (
    <CollapsableCard canCollapse={false} type='info'>
      <Body>
        <div style={{ marginBottom: '15px' }}>
          <Label
            style={{
              fontWeight: 'bold',
              color: '#a5a5a5',
            }}
          >
            Numéro de campagne
          </Label>
          <br />
          <div className='row'>
            <div className='col-md-2'>
              <NumericTextBox
                width={200}
                value={value}
                onChange={ChangeValue}
              />
            </div>
            <div className='col-md-2'>
              <Button className='blueButton' onClick={addList}>
                Ajouter
              </Button>
            </div>
          </div>
        </div>
        {dataList.length !== 0 && (
          <div>
            <ListView
              data={dataList}
              item={MyItemRender}
              style={{
                width: '100%',
                maxHeight: 585,
              }}
            />
            <Button
              className='blueButton'
              onClick={handleSubmit}
              style={{
                marginTop: '15px',
              }}
            >
              Générer
            </Button>
            {loadingXlsx && <Loader size='small' type={'infinite-spinner'} />}
            <a
              ref={linkRef}
              download={true}
              rel='noreferrer'
              target='_blank'
              href={base64Xlsx}
            />
          </div>
        )}
      </Body>
    </CollapsableCard>
  );
}
